export default __webpack_public_path__ + "static/media/camera.b2af296d.svg";